import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router"; // Router içeri alındı
import { PoolService } from "src/app/services/pool.service";
import { MatDialog } from "@angular/material/dialog";
import { ManualMovementDialogComponent } from "./manual-movement-dialog.component";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { MomentDateAdapter } from "@angular/material-moment-adapter";

import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";

const moment = _moment;

export interface UserElement {
  id: number;
  username: string;
  name: string;
  donem: number;
  depart: string;
  useServiceArrival: boolean;
  serviceArrival: string;
  useServiceGoing: boolean;
  serviceGoing: string;
}

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "LL",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

export interface EmployeeMovementReportDto {
  employeeId: number;
  employeeCode: string;
  fullName: string;
  date: string;
  firstIn?: string;
  lastOut?: string;
  insideHours: number;
  leaveHours: number;
  overtimeHours: number;
  isRemoteWork: boolean;
  monthlyTotalRemoteWorkDays: number;
  totalWorkHours: number;
  status: string;
}

@Component({
  selector: "app-inandout",
  templateUrl: "./inandout.component.html",
  styleUrls: ["./inandout.component.scss"],
  providers: [
    // {provide: DateAdapter, useClass: OutofofficeComponent},
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true } },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class InandoutComponent implements OnInit {
  reports: EmployeeMovementReportDto[] = [];
  filteredReports: EmployeeMovementReportDto[] = [];
  searchTerm: string = "";

  companyId: number = 1;
  startDate: string = "";
  endDate: string = "";
  loading: boolean = false;

  // Rapor Alt Toplamları (Saat Cinsinden)
  totalInside: number = 0;
  totalLeave: number = 0;
  totalOvertime: number = 0;

  // Üst Panel İstatistik Sayaçları (Kişi Sayısı Cinsinden)
  activePunchesCount: number = 0; // Kart basıp fiilen gelen kişi sayısı
  totalDailyLeavesCount: number = 0; // O gün tam gün izinli olan kişi sayısı
  remoteWorkersCount: number = 0; // O gün evden çalışan kişi sayısı

  constructor(
    private poolService: PoolService,
    private router: Router,
    public dialog: MatDialog,
  ) {
    const today = new Date().toISOString().split("T")[0];
    this.startDate = today;
    this.endDate = today;
  }

  ngOnInit(): void {
    this.loadReport();
  }

  goHome(): void {
    this.router.navigate(["/main"]); // Ana sayfa rotanız neyse ('/dashboard', '/home' vb.) buraya yazabilirsiniz
  }

  loadReport(): void {
    this.loading = true;
    this.poolService
      .dailySummary(this.companyId, this.startDate, this.endDate)
      .subscribe({
        next: (data) => {
          this.reports = Array.isArray(data) ? data : [data];
          this.filterReports();
          this.loading = false;
        },
        error: (err) => {
          console.error("Rapor yüklenirken hata oluştu:", err);
          this.loading = false;
        },
      });
  }

  openManualModal(row: any): void {
    const dialogRef = this.dialog.open(ManualMovementDialogComponent, {
      width: "400px",
      maxWidth: "95vw", // Mobil uyum için
      data: {
        employeeId: row.employeeId,
        fullName: row.fullName,
        date: row.date,
        companyId: this.companyId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadReport(); // Kaydedilirse raporu otomatik yenile, bakiye/saat yeniden hesaplansın
      }
    });
  }

  filterReports(): void {
    const term = this.searchTerm.toLowerCase().trim();

    console.log(this.reports);
    // 1. Arama filtresini uygula
    this.filteredReports = this.reports.filter(
      (r) =>
        r.fullName.toLowerCase().includes(term) ||
        r.employeeCode.includes(term),
    );

    console.log(this.filteredReports);
    // 2. Tablo altındaki saat bazlı toplamları hesapla
    this.totalInside = this.filteredReports.reduce(
      (sum, r) => sum + r.insideHours,
      0,
    );
    this.totalLeave = this.filteredReports.reduce(
      (sum, r) => sum + r.leaveHours,
      0,
    );
    this.totalOvertime = this.filteredReports.reduce(
      (sum, r) => sum + r.overtimeHours,
      0,
    );

    // 3. Üst paneldeki kişi bazlı durum sayaçlarını hesapla
    this.activePunchesCount = this.filteredReports.filter(
      (r) => r.insideHours > 0,
    ).length;
    this.totalDailyLeavesCount = this.filteredReports.filter((r) =>
      r.status.includes("İzinli (Tam Gün)"),
    ).length;
    this.remoteWorkersCount = new Set(
      this.filteredReports
        .filter((r) => r.isRemoteWork)
        .map((r) => r.employeeId),
    ).size;
  }
}
